import { render } from "./TheLichVeSinhDoThiKhac.vue?vue&type=template&id=add2a38c"
import script from "./TheLichVeSinhDoThiKhac.vue?vue&type=script&lang=js"
export * from "./TheLichVeSinhDoThiKhac.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__